import vAlert from './Alert';

export { vAlert };


// WEBPACK FOOTER //
// ./src/baseComponents/components/Alert/index.js